import type { Follow } from "@tandemdiabetes/sugarmate-api-react-client"
import { AccountItem } from "./AccountItem"
import styles from "./AccountList.module.scss"

interface Props {
  headerTitle: string;
  follows: Follow | Follow[];
  closeMenu: () => void;
}

export function AccountList(props: Props) {
  const {
    closeMenu,
    headerTitle,
    follows,
  } = props

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        {headerTitle}
      </div>
      {Array.isArray(follows) ? (
        follows.map(
          (follow) => (
            <AccountItem
              key={follow.id}
              follow={follow}
              onClick={closeMenu}
            />
          ),
        )
      ) : (
        <AccountItem
          follow={follows}
          onClick={closeMenu}
        />
      )}

    </div>
  )
}
